
import { QueryClient as TanStackQueryClient } from '@tanstack/react-query';

// Creating a type alias to make the migration easier
export type QueryClient = TanStackQueryClient;

export const queryClient = new TanStackQueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// This function creates and returns a new QueryClient instance
// with the same default configuration
export const createQueryClient = () => {
  return new TanStackQueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  });
};
